const ACCESS_TOKEN_COOKIE_PREFIX = 'access-token=';

const NAMED_ACCESS_TOKEN_PATTERN = /(?:^|;\s*)access-token\s*=/i;
const NAMED_ACCESS_TOKEN_KEYS_PATTERN = /(^|;\s*)access-token\s*=\s*/gi;
const LEADING_ACCESS_TOKEN_KEYS_PATTERN = /^(?:access-token\s*=\s*)+/i;

function stripSurroundingQuotes(value: string): string {
  const first = value[0];
  if (value.length >= 2 && (first === '"' || first === "'") && value.endsWith(first)) {
    return value.slice(1, -1).trim();
  }
  return value;
}

export function normalizeAccessToken(value: string | null | undefined): string {
  const trimmed = stripSurroundingQuotes(value?.trim() ?? '');
  if (!trimmed) return '';

  if (trimmed.includes(';') && NAMED_ACCESS_TOKEN_PATTERN.test(trimmed)) {
    return trimmed.replace(NAMED_ACCESS_TOKEN_KEYS_PATTERN, `$1${ACCESS_TOKEN_COOKIE_PREFIX}`);
  }

  const token = stripSurroundingQuotes(
    trimmed.replace(LEADING_ACCESS_TOKEN_KEYS_PATTERN, '').trim()
  );
  return token ? `${ACCESS_TOKEN_COOKIE_PREFIX}${token}` : '';
}
